var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99992 9.84726C9.14867 9.84726 10.0799 8.91601 10.0799 7.76726C10.0799 6.6185 9.14867 5.68726 7.99992 5.68726C6.85117 5.68726 5.91992 6.6185 5.91992 7.76726C5.91992 8.91601 6.85117 9.84726 7.99992 9.84726Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.4133 6.55396C3.72664 0.78063 12.28 0.787297 13.5866 6.56063C14.3533 9.9473 12.2466 12.814 10.4 14.5873C9.05997 15.8806 6.93997 15.8806 5.5933 14.5873C3.7533 12.814 1.64664 9.94063 2.4133 6.55396Z",
    stroke: "white",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0bf1bfe389783aba3f6d4fc217befaf3.svg";
export { ForwardRef as ReactComponent };